import { useMemo } from 'react';

import { ExpandableTextSection } from '@infinex-private/connect-web-shared/components';
import { cn } from '@infinex/ui-styles';

interface SignableInfoItemProps {
  rawData: string | null;
  title?: string;
  defaultExpanded?: boolean;
  expandable?: boolean;
  className?: string;
}

export function SignableInfoItem({
  rawData,
  title,
  defaultExpanded = false,
  expandable = true,
  className,
}: SignableInfoItemProps) {
  // Try to parse as JSON and format it
  const formattedData = useMemo(() => {
    if (!rawData) return '';

    try {
      // Try to parse as JSON
      const parsed = JSON.parse(rawData);
      return JSON.stringify(parsed, null, 2);
    } catch {
      // If not JSON, return as-is
      return rawData;
    }
  }, [rawData]);

  const isJson = formattedData !== rawData;

  if (!rawData) return null;

  return (
    <ExpandableTextSection
      className={className}
      defaultExpanded={defaultExpanded}
      fadeGradientFrom="from-surface"
      expandable={expandable}
      title={title}
      lineThreshold={4}
    >
      <pre
        className={cn(
          'text-tertiary text-sm break-all whitespace-pre-wrap',
          // eslint-disable-next-line better-tailwindcss/no-unknown-classes
          isJson && 'language-json'
        )}
      >
        {formattedData}
      </pre>
    </ExpandableTextSection>
  );
}
